import {
  Button,
  Classes,
  Menu,
  MenuDivider,
  MenuItem,
} from '@blueprintjs/core';
import { useApplicationDetail } from '@axo/shared/data-access/hooks';
import { classNames } from '@axo/shared/util/dom';
import styles from './PortfolioNavigation.module.css';
import { useContext } from 'react';
import { useAssignedApplicationIds } from '../../hooks/utils/useAssignedApplicationIds';
import { useLockAndOpenApplication } from '../../hooks/utils/useLockAndOpenApplication';
import { ApplicationContext } from '../../store/context';
import { MarketCountryCode } from '@axo/shared/types';
import { useNavigate } from 'react-router-dom';

export const NewApplicationsTooltip: React.FC = () => {
  const { state } = useContext(ApplicationContext);
  const marketCountry = state.marketCountry ?? '';
  const applicationIds = useAssignedApplicationIds(marketCountry);

  const open = useLockAndOpenApplication(
    marketCountry as MarketCountryCode
  );

  function fetchAndOpenApplications() {
    applicationIds.forEach((id) => {
      open({
        LoanApplicationID: id,
        HumanReadableID: '',
      });
    });
  }

  return (
    <div className={classNames(styles.newApplicationsTooltip, Classes.DARK)}>
      <Menu className={styles.newApplicationsMenu}>
        <MenuDivider title="New applications:" />
        {applicationIds.map((id) => (
          <ApplicationMenuItem key={id} applicationID={id} />
        ))}
        <MenuItem
          className={styles.openAllMenuItem}
          text="Open all"
          onClick={fetchAndOpenApplications}
        />
      </Menu>
    </div>
  );
};

function ApplicationMenuItem({ applicationID }: { applicationID: string }) {
  const appDetail = useApplicationDetail(applicationID);
  const { dispatch } = useContext(ApplicationContext);
  const navigate = useNavigate();

  if (appDetail.isLoading) {
    return <span className={Classes.SKELETON}>loading</span>;
  }

  if (appDetail.error || !appDetail.data) {
    return <Button text="reload" onClick={() => appDetail.refetch()} />;
  }

  return (
    <MenuItem
      data-testid={appDetail.data.ID}
      onClick={() => {
        dispatch({
          type: 'Open application',
          payload: {
            humanReadableID: appDetail.data.HumanReadableID ?? '',
            marketCountry: appDetail.data.MarketCountry,
          },
          scope: {
            parentType: 'navigation',
            id: appDetail.data.ID,
          },
        });
        navigate(`/application/${appDetail.data.ID}`);
      }}
      text={appDetail.data?.HumanReadableID ?? 'Application ID is missing'}
    />
  );
}
